export default __webpack_public_path__ + "static/media/i2700.852ad890.jpg";